import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import { Item } from './common'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'faq'

/**
 * This is the component description.
 */
const FAQ = ({
  id,
  className:userClassName,
  style,
  children,
}) => (
  <div
    id={id}
    className={[
      baseClassName,
      componentClassName,
      userClassName,
    ]
      .filter((e) => e)
      .join(' ')}
    style={style}
  >
    {children}
  </div>
)

FAQ.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * The children jsx
   */
  children:PropTypes.node,
}

FAQ.Item = Item

FAQ.defaultProps = {
  // color:'teal',
}

export default FAQ
